module.exports = __webpack_public_path__ + "static/img/4807_phase_function_Paper_Points.b9f002e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4807_phase_function_Paper_Points.png
// module id = efMb
// module chunks = 0